import * as getters from '@/store/modules/approvals/getters'
import * as mutations from '@/store/modules/approvals/mutations'
import * as actions from '@/store/modules/approvals/actions'

const state = {
    accountsBalances: [],
    accountsWithOperationsPendingSignature: [],
    operationDetails: [],
    accountsList: [],
    profilesList: [],
    operatorDetails: {},
    totalNumberOfOperationsToSign: null,
    operationsTypesList: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
